import script from "./Chart.vue?vue&type=script&setup=true&lang=js"
export * from "./Chart.vue?vue&type=script&setup=true&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=311017bc&lang=scss"

const __exports__ = script;

export default __exports__